import { Button, Grid, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { getNodeById, saveNodeById, saveNodeByIdOps } from '../../api/node';
import { useDispatch } from 'react-redux';
import { UiActionType } from '../../reducers/ui.reducer';
import { Node, NodeStatus, NodeTypeName } from '../../domain/domain';
import { ALL_NODE_TYPES, getNodeTypeNameText } from '../ComponentManagementPage/utils';

const OpsUpdateNodeTool : React.FC = () => {

    const [rawNodeId, setRawNodeId] = useState<string>("");
    const [node, setNode] = useState<Node | undefined>(undefined);
    const dispatch = useDispatch();
    
    const isFormValid = () => {
        if (node === undefined) {
            return false;
        }
        return true;
    }

    return (
        <Grid container direction='column' spacing={2}>
            <Grid item>
                <Typography variant='h2'>Update an existing node</Typography>
            </Grid>
            <Grid item>
                <Grid container direction='row' spacing={2}>
                    <Grid item>
                        <TextField variant='outlined' size='small' label='Node Id' value={rawNodeId} onChange={(event) => {
                            setRawNodeId(event.target.value);
                        }}></TextField>
                    </Grid>
                    <Grid item>
                        <Button variant='contained' color='secondary' disabled={!rawNodeId} onClick={() => {
                            getNodeById(parseInt(rawNodeId)).then(response => {
                                setNode(response.data);
                            }).catch(error => {
                                dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: true, message: "Node not found", severity: "error" } });
                                console.error(error);
                            })
                        }}>Find Node</Button>
                    </Grid>
                </Grid>
            </Grid>
            {node !== undefined &&
                <Grid item>
                    <Grid container direction='column' spacing={1}>
                        <Grid item>
                            <TextField variant='outlined' size='small' label='Parent Id' InputLabelProps={{shrink: true}} value={node.parentId} onChange={(event) => {
                                setNode({...node, parentId: parseInt(event.target.value)})
                            }}></TextField>
                        </Grid>
                        <Grid item>
                            <TextField size='small' label='Heading' variant='outlined'  InputLabelProps={{shrink: true}} value={node.heading} onChange={(event) => {
                                setNode({...node, heading: event.target.value})
                            }}></TextField>
                        </Grid>
                        <Grid item>
                            <TextField size='small' label='Citation' variant='outlined'  InputLabelProps={{shrink: true}} value={node.citation} onChange={(event) => {
                                setNode({...node, citation: event.target.value})
                            }}></TextField>
                        </Grid>
                        <Grid item>
                            <TextField size='small' label='Ordinal' variant='outlined'  InputLabelProps={{shrink: true}} value={node.ordinal} onChange={(event) => {
                                setNode({...node, ordinal: parseInt(event.target.value)})
                            }}></TextField>
                        </Grid>
                        <Grid item>
                            <Select placeholder='Node Status' variant='outlined' value={node.status} onChange={(event: any) => {
                                setNode({...node, status: event.target.value as NodeStatus})
                            }}>
                                <MenuItem value={NodeStatus.CHANGED_NOT_APPROVED}>Changed Not Approved</MenuItem>
                                <MenuItem value={NodeStatus.APPROVED}>Approved</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item>
                            <Select placeholder='Node Type' variant='outlined' value={node.nodeType} onChange={(event: any) => {
                                setNode({...node, nodeType: event.target.value as NodeTypeName})
                            }}>
                                {ALL_NODE_TYPES.map(nodeType => {
                                    return (
                                        <MenuItem value={nodeType}>{getNodeTypeNameText(nodeType)}</MenuItem>
                                    )
                                })}
                            </Select>
                        </Grid>
                    </Grid>
                </Grid>
            }
            <Grid item>
                <Button color='primary' disabled={!isFormValid()} variant='contained' onClick={() => {
                    if (node === undefined) {
                        return;
                    }
                    saveNodeByIdOps(node).then(response => {
                        dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: true, message: "Node updated", severity: "success" } });
                    }).catch(error => {
                        dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: true, message: "Could not update node", severity: "error" } });
                        console.error(error);
                    })
                }}>Update</Button>
            </Grid>
        </Grid>
    )
}

export default OpsUpdateNodeTool;